import styled from '@emotion/styled';

const TextDiv = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
  marginTop: 6
});

export default TextDiv;
